<template>

    <header class="header">

        <nav class="navbar" role="navigation" aria-label="main navigation">

            <div class="navbar-brand">

                <div class="navbar-item">
                  <img class="logo" :src="clientLogoURL" :alt="clientName" v-if="clientLogoURL">
                  <div class="label has-margin-left-large">{{clientName}}</div>
                </div>

            </div>

        </nav>

    </header>

</template>

<script setup lang="ts">

  import { computed } from "vue";
  import {storeToRefs} from "pinia";
  import {useClientStore} from '@/stores/ClientStore';

  const {client} = storeToRefs(useClientStore());

  const clientLogoURL = computed<string | null>(() => client.value?.logo_url || null);

  const clientName = computed(() => client.value?.name || 'SubsPortal');

</script>

<style lang="scss" scoped>
    header.header {
        font-size: 16px;

        .navbar-item {
          height: 5.25rem;
        }

        .logo {
            max-height: 5.25rem;
        }
    }
</style>
